export default {
  props: {
    form: {
      type: Object,
      default: () => ({})
    },

    terminalRegions: {
      type: Array,
      default: () => []
    },

    approveForm: {
      type: Object,
      default: () => ({})
    },

    errors: {
      type: Object,
      default: () => ({})
    },

    periodOfDateOptions: {
      type: Object,
      default: () => ({
        minDate: null,
        maxDate: null,
        disabledDates: []
      })
    },

    periodToDateOptions: {
      type: Object,
      default: () => ({
        minDate: null,
        maxDate: null,
        disabledDates: []
      })
    }
  },

  computed: {
    terminalRegion() {
      return this.terminalRegions.find(region => region.id === this.form.application.terminal_region_id);
    }
  }
}
